import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { LOGIN_WITH_EMAIL } from '../graphql/mutations'
import { LOGIN } from '../redux/action-types'

const useEmailLoginMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.account.login)

  const mutate = useCallback(
    (email, code) =>
      apolloService.mutate(LOGIN_WITH_EMAIL, { email, code }, dispatch, LOGIN),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useEmailLoginMutation
